export class Paciente {

    id: number = 0;

    nome: string = '';

    cpf: string = '';

    dataNascimento: Date = new Date();

    foneResidencial: string = '';

    foneCelular: string = '';

    dependentes: Array<Paciente> = [];

    titular: Paciente | undefined;

    dependenteAtivo: boolean = false;

    dependentesExcluidos: Array<Paciente> = [];

    constructor() {
    }
}
